import { useEffect, useState } from "react";
import { FormRecaudarPrepago } from "../interfaces/formRecaudarPrepago.Interface";
import { selectorTransversal } from "../../../dtos/selector";
import { obtenerFormasPagoPrepagoService } from '../services/servicePrepago';
import { RespuestaFormaPagoPrepagoDto } from "../models";
import { AxiosResponse } from "axios";
import { ListResponseDto } from "../../../dtos/ListResponseDto";

const sucursalPago = [
    { value: 'CAJA', label: 'Caja' },
    { value: 'INVERSIONISTA', label: 'Inversionista' },
];

export function useRecaudarSolicitud(initialValues: Partial<FormRecaudarPrepago>) {
    console.log('useRecaudarSolicitud - initialValues recibidos:', initialValues);

    const [ defaultValues ] = useState<FormRecaudarPrepago>({
        id: initialValues?.id || 0,
        mutuoId: initialValues?.mutuoId || 0,
        fechaSolicitud: initialValues?.fechaSolicitud || new Date(),
        fechaPago: initialValues?.fechaPago || new Date(),
        motivo: initialValues?.motivo || '',
        tipo: initialValues?.tipo || '',
        modo: initialValues?.modo || '',
        montoPrepagoCapital: initialValues?.montoPrepagoCapital || '',
        comision: initialValues?.comision || '',
        interesDevengado: initialValues?.interesDevengado || '',
        segurosMes: initialValues?.segurosMes || '',
        montoDividendosImpagos: initialValues?.montoDividendosImpagos || '',
        interesPenalDividendos: initialValues?.interesPenalDividendos || '',
        gastosCobranzaDividendos: initialValues?.gastosCobranzaDividendos || '',
        totalPagar: initialValues?.totalPagar || '',
        sucursalPago: initialValues?.sucursalPago || 'CAJA',
        fechaRecaudacion: initialValues?.fechaRecaudacion || new Date(),
        formaPago: initialValues?.formaPago || '1',
        prepagoCliente: initialValues?.prepagoCliente || null,
    });

    console.log('useRecaudarSolicitud - defaultValues finales:', defaultValues);

    const [listSucursalPago] = useState<selectorTransversal[]>(sucursalPago);
    const [listFormaPago, setListFormaPago] = useState<selectorTransversal[]>([]);

    const obtenerFormasPagoPrepago = async (): Promise<void> => {
        try {
            const response: AxiosResponse<ListResponseDto<RespuestaFormaPagoPrepagoDto>> = await obtenerFormasPagoPrepagoService();
            const formasPagoPrepago = response.data.items;
            const formasAdapted = formasPagoPrepago.map(forma => ({value: forma.codigo, label: forma.descripcion}));
            setListFormaPago(formasAdapted);
        } catch (error) {
            console.error(error);
            throw(error);
        }
    };

    useEffect(() => { obtenerFormasPagoPrepago() }, [])

    return {
        defaultValues,
        listSucursalPago,
        listFormaPago
    };
}